import { render, staticRenderFns } from "./PlanningGroupsPage.vue?vue&type=template&id=6e4d68d9&scoped=true&lang=pug&"
import script from "./PlanningGroupsPage.vue?vue&type=script&lang=ts&"
export * from "./PlanningGroupsPage.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningGroupsPage.vue?vue&type=style&index=0&id=6e4d68d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d68d9",
  null
  
)

export default component.exports